import { CallWidgets } from './components/call-widgets'

export const SharedWidgets = () => {
    return <CallWidgets />
}
